import Image from "next/image";
import Button from "@xtribe/shared/components/lib/Button";
import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import Layout from "@xtribe/shared/components/lib/Layout/Layout";
import HomepageNavbar from "@xtribe/shared/components/lib/Navbar/HomepageNavbar";
import { addColorAlpha, hexToRgb } from "@xtribe/shared/utils/color";
import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import Slider from "../components/Slider/Slider";
import Link from "next/link";
import xtribeIslandImage from "../public/static/mission/xtribe-island.png";
const Index = () => {
  const [colorState, setColorState] = useState({
    text: "text-black",
    textSoft: "text-gray-200",
    bg: "bg-green-light",
    bgSoft: "bg-green-light",
  });

  const [lightGreenDiv1, lightGreen1InView] = useInView({
    /* Optional options */
    threshold: 0.1,
  });
  const [greenDiv1, green1InView] = useInView({
    /* Optional options */
    threshold: 0.1,
  });
  useEffect(() => {
    if (lightGreen1InView) {
      setColorState({
        text: "text-black",
        textSoft: "text-gray-600",
        bg: "bg-green-light",
        bgSoft: "bg-green-background",
      });
    } else if (green1InView) {
      setColorState({
        text: "text-white",
        bg: "bg-green",
        textSoft: "text-gray-200",
        bgSoft: "bg-green-pastel",
      });
    }
  }, [lightGreen1InView, green1InView]);

  return (
    <div
      className={`theme-admin overflow-x-hidden overflow-y-hidden transition-colors duration-300 ease-out ${colorState.bg} ${colorState.text}`}
    >
      <NextHead
        title={"Turn your audience into your Tribe — xTribe"}
        description={
          "Vermarkte eigenen Content und biete Premium-Abonnements, die es in sich haben und erschaffe dein ortsunabhängiges Business, rund um deine kreative Arbeit."
        }
      />
      <HomepageNavbar />
      <Layout>
        <div
          ref={lightGreenDiv1}
          className={`mt-16 max-w-7xl mx-auto overflow-hidden px-4`}
        >
          <div
            className={`transition-opacity duration-700 ease-out ${
              lightGreen1InView ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
          >
            <div className="text-center mb-6 pt-8 md:pt-12 md:mb-12 px-2 md:px-4">
              <h1 className="h1 normal-case font-bold mb-4  tracking-tighter">
                xTribe Island –
                <br />
                Warum wir eine Insel kaufen
              </h1>

              <div className="mt-24">
                <Image src={xtribeIslandImage} />
              </div>
            </div>
            <div className="mt-32 mb-64">
              <div className="">
                <div className="">
                  <h6 className="h6 text-red">Here is why</h6>
                  <h2 className="mt-4 h3">
                    <span className="text-green-dark">
                      Es gibt nichts Schöneres und Größeres, als Wissen zu
                      vermitteln oder zu lernen. Das war schon immer so und soll
                      auch immer so bleiben. <br />
                    </span>{" "}
                    <span className="opacity-60">Wir glauben an die</span>{" "}
                    <span> Balance</span>{" "}
                    <span className="opacity-60 ">
                      zwischen digitaler Reichweite und echtem Kontakt mit
                      Menschen.
                    </span>
                    <span className="opacity-60 block">
                      xTribe ist der digitale und physische Ort, an dem du nicht
                      nur lernen und dich austauschen kannst, sondern an dem du
                      deine Fähigkeiten auf xTribe-Island zu perfektionieren
                      lernen kannst.
                    </span>
                    <br />
                    <span className="opacity-60 block">
                      Diese Balance wird für uns verkörpert durch die
                      Kombination der digitalen Möglichkeit, eine Fähigkeit
                      völlig ortsunabhängig zu erlernen und die Gelegenheit zu
                      haben, noch tiefer einzutauchen und sie in einer
                      physischen Umgebung mit gleichgesinnten Tribe-Membern zu
                      meistern.
                    </span>
                    <br />
                    <span className="opacity-60 block">
                      Werde zum Leader deines Tribes. Kümmere dich um die Leute,
                      die an dich glauben und gerne deinen Live Kurs buchen,
                      deinen erstellten Content kaufen und dich verdammt nochmal
                      Live auf einer Insel sehen wollen.
                    </span>
                    Vertrauen und Vielseitigkeit macht aus fremden Fans einen
                    einzigartigen Tribe. Deinen Tribe.
                    <br />
                  </h2>
                  <h3 className="mt-16 h1 normal-case font-bold mb-4 tracking-tighter text-green">
                    Welcome to xTribe.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={greenDiv1} className="min-h-screen px-4 mt-64">
          <div
            className={`transition-opacity duration-700 ease-out ${
              green1InView ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
          >
            <div className=" max-w-7xl mx-auto text-center mt-96">
              <h1 className="text-5xl sm:text-6xl  md:text-7xl tracking-tighter leading-none normal-case font-bold mb-4">
                Bist du bereit loszulegen?
              </h1>
            </div>
            <div className="h-16" />
            <div className=" max-w-2xl mx-auto text-center py-96">
              <h1 className="h1">
                <span className="text-green-dark">Don't forget: </span>
                your vibe attracts your tribe
              </h1>
              <div className="h-6" />
              <Link href="/start" passHref>
                <a>
                  <Button size="large" homepageBtn type="success" ghost>
                    Erschaffe deinen Tribe &rarr;
                  </Button>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </Layout>
      <style jsx global>{`
        :root {
          --color-background: ${colorState.bg};
          --color-background-soft: ${colorState.bgSoft};
          --color-foreground: ${colorState.text};
          --color-foreground-soft: ${colorState.textSoft};
        }
      `}</style>
    </div>
  );
};

export default Index;
